module.exports = __webpack_public_path__ + "static/media/home-vpc.83a523c7.svg";